<template>
    <div class="fixwidth overflow_hide box">
        <div class="upload-box" @click="openWork">
            <div class="icon"><i class="el-icon-circle-plus"></i></div>
            <div class="text">发布作业</div>
        </div>

        <!--发布作业开始-->
        <el-dialog  class="elDialog abow_dialog" :close-on-click-modal="false" title="发布作业" :visible.sync="workVisible">
            <el-form class="form" ref="form" :model="work" label-width="80px">
                <el-form-item label="作业标题">
                    <el-input v-model="work.jobName"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input rows=2 type="textarea" v-model="work.remark"></el-input>
                </el-form-item>
                <el-upload
                        ref="upload"
                        class="upload"
                        style="margin-left:20px"
                        action=""
                        :file-list="workList"
                        :auto-upload=false
                        :http-request="uploadWork"
                        :on-change="handleChange">
                    <!--:show-file-list=false-->
                    <div class="btn">
                        <button @click="chooseFile">上传文件</button>
                    </div>
                </el-upload>


                <el-form-item label="选择班级:"  style="text-align: left;margin-top:10px;">
                    <el-select v-model="gradeId" multiple placeholder="请选择">
                        <el-option
                                v-for="item in grades"
                                :key="item.gradeId"
                                :label="item.gradeName"
                                :value="item.gradeId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="完成时间" style="text-align: left;margin-top:10px;">
                    <el-date-picker
                            v-model="work.completionTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            default-time="12:00:00">
                    </el-date-picker>
                </el-form-item >
                <el-form-item label-width="0">
                    <el-button type="primary" @click="submitWork">确认发布</el-button>
                    <el-button @click="workVisible = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--发布作业结束-->

        <!--作业管理列表-->
        <div>
            <div class="list-title">
                <div>序号</div>
                <div>作业名称</div>
                <div>作业类型</div>
                <div>发布时间</div>
                <div>要求完成时间</div>
                <div>操作</div>
            </div>
            <div v-if="workManageList.length===0">暂无数据</div>
            <div class="list" v-for="(l,index) in workManageList" :class="l.status===0?'color-orange':''">
                <div>{{index+1}}</div>
                <div>{{l.jobName}}</div>
                <div>{{l.type}}</div>
                <div>{{l.createTime}}</div>
                <div>{{l.completionTime}}</div>
                <div>
                    <!--<button class="check-btn" @click="previewWork(l)">预览</button>-->
                    <!--<button class="check-btn" @click="editWork(l)">修改</button>-->
                    <button class="check-btn" @click="deleteWork(l)">删除</button>
                </div>
            </div>
            <Pagination :size=workManageList.length :pageLimit=8 style="margin:20px 0"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        name: "PublicWork",
        components:{Pagination},
        data(){
            return{
                work:{                       //上传作业时提交json
                    jobName:"",
                    remark:"",
                    completionTime:"",
                    taskRelations:[],
                    url:"",
                    userId:this.$store.getters.getToken.userId
                },
                schedule:[],
                workVisible:false,
                workList:[],                 //上传作业的文件
                workManageList:[],                  //作业管理列表
                grades:[],                        //所有班级列表
                gradeId:[],
                operateWorkType:"add",              //区分操作作业是add还是edit
                editWorkId:"",                      //记录修改作业的id
                chapterList:[],
                workInfo:{
                    pageObject:{
                        pageSize:8,
                        currentPage:1
                    },
                    model:{
                        userId:this.$store.getters.getToken.userId
                    }
                }
            }
        },
        created() {
            this.getAllWork(this.workInfo);
        },
        methods:{
            openWork(){
                this.operateWorkType="add";
                this.workVisible=true;
                this.workList=[];
                //this.getAllGrade();
                this.work={                       //上传作业时提交json
                        jobName:"",
                        remark:"",
                        completionTime:"",
                        taskRelations:[],
                        url:"",
                        userId:this.$store.getters.getToken.userId
                };
            },
            submitWork(){
                for(let i in this.gradeId){
                    this.work.taskRelations.push({gradeId:this.gradeId[i]});
                }
                let data = JSON.parse(JSON.stringify(this.work));
                data.completionTime = this.common.formatDateAndTime(this.work.completionTime,"/");
                switch (this.operateWorkType) {
                    case "add":
                        this.$json("/job","POST",data).then(res=>{
                            if(res.code===200){
                                this.$message("添加成功");
                                this.workVisible=false;
                                this.getAllWork(this.workInfo);
                            }
                        });
                        break;
                    case "edit":
                        let postData = JSON.parse(JSON.stringify(this.work));
                        postData.jobId = this.editWorkId;
                        this.$put("/job",postData).then(res =>{
                            if(res.code===200){
                                this.$message("修改成功");
                                this.workVisible=false;
                                this.getAllWork();
                            }
                        })
                }
            },
            //修改上传的作业列表
            handleChange(file, fileList) {
                this.workList = fileList;
            },
            chooseFile(e){
                e.preventDefault();
            },
            //获取字典类型
            getDic(pCode){
                let data={pCode:pCode};
                return new Promise((resolve,reject) => {
                    this.$post("/Dic/getAll", data).then(function (response) {
                        resolve(response);
                    });
                })
            },
            getAllWork(data){
                this.$json("/job/list","POST",data).then(res =>{
                    this.workManageList = res.data.data;
                });
            },
            previewWork(l){
            },
            editWork(l){
                this.operateWorkType = "edit";
                this.workVisible=true;
                this.work = {
                    jobName:l.jobName,
                    remark:l.remark,
                    completionTime:l.completionTime,
                    resourceId:l.resourceId
                };
                this.editWorkId = l.jobId;
            },
            deleteWork(l){
                console.log(l);
            },
            getAllGrade(){
                let postData={userId:this.$store.getters.getToken.userId};
                this.$post("ywTeacherGrade/TeacherGradeAll",postData).then(res =>{
                    this.grades= res.data;
                });
            },
            uploadWork(e){
                let upload = new FormData();
                upload.append("file", e.file);
                this.$upload("/question/upload", upload).then(res => {
                    this.work.url = res.data;
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/css/myCourse.less';
    .list:nth-child(odd), .list-title {
        background-color: #edf5ff;
    }

    .box{
        //height:400px;
    }
    .upload-box{
        margin:20px;
        width:175px;
        height:112px;
        border:1px solid #c9c9ca;
        float:left;
        cursor: pointer;
        .icon{
            width:55px;
            height:55px;
            margin:10px auto 0;
            i{
                font-size:50px;
                color:#e6e6e6;
            }
        }
        .text{
            font-size:24px;
            color:#e6e6e6;
        }
    }

    .form{
        padding:0 20px;
        overflow: auto;
        /*height: calc(100% - 80px);*/
        height:100%;
        .upload{
            text-align:left;
            padding-left:60px;
            .btn{
                text-align: left;
                button{
                    width:120px;
                    height:60px;
                    border:1px solid #9dc1fb;
                    border-radius: 5px;
                    background: linear-gradient(#fefefe, #dae6fe);
                    color:#6fa9fd;
                    font-size:18px;
                    cursor: pointer;
                    position: relative;
                }
                button:active{
                    top:1px;
                    left:1px;
                }
            }
        }

    }


    /deep/.el-dialog__header{
        background-color: #b0d1fa;
        span{
            color:#fff;
            font-size:30px;
            text-shadow: 1px 1px 1px #ccc;
        }
        button i{
            color:#fff;
            font-size:20px;
        }
    }
    /deep/.el-dialog__body{
        background-color: #eff6ff;
    }

    /deep/.abow_dialog {
        overflow: hidden;
        .el-dialog {
            height:80%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 20px;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
